import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/about/components/base-section/base-section.tsx");
